import { Controller } from "@hotwired/stimulus";

// 重要なお知らせ（TOPリニューアル top-notice-block）のSP用「もっと見る」開閉。
// PCは.top-notice-block__toggle-panelが常時表示のためCSSのみで完結し、このコントローラは使われない。
export default class extends Controller {
  static targets = ["contents", "panel", "button"];

  toggle() {
    this.contentsTarget.classList.toggle("is-open");
    const isOpen = this.contentsTarget.classList.contains("is-open");
    this.panelTarget.style.display = isOpen ? "flex" : "none";
    // 開閉状態を支援技術に伝える（buttonTargetが無い場合もあるためガードする）。
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", isOpen);
      this.buttonTarget.textContent = isOpen ? "閉じる" : "もっと見る";
    }
  }
}
